<template>
  <section style="margin-bottom: 100px">
    <div class="cl-cantainer container" v-if="!keyword">
      <!-- 引入banner头 -->
      <public-banner
        :publicBannerList="publicBannerList"
        :publicShuffling="publicShuffling"
      ></public-banner>
      <el-row class="row">
        <el-col class="col-md-9 cl-left" :span="17">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-tabs
                v-model="activeName"
                type="card"
                class="elTabs"
                @tab-click="handleClick"
              >
                <el-tab-pane :label="$t('最新')" name="first"></el-tab-pane>
                <el-tab-pane :label="$t('最新视频')" name="second"></el-tab-pane>
              </el-tabs>
            </div>
            <!--哈法看点 -->
            <div v-if="activeName == 'first'" id="iii">
              <ha-faList :listData="listData"></ha-faList>
              <!-- 论坛 -->
              <bbs :listData="listData"></bbs>
              <!-- 今日折扣 -->
              <today-discount :listData="listData"></today-discount>
              <!-- 本地生活 -->
              <local-life :listData="listData"></local-life>
              <!-- 二手交易 -->
              <trading :listData="listData"></trading>
              <!-- 租房 -->
              <rent-house :listData="listData"></rent-house>
              <!-- 二手车 -->
              <two-handcart :listData="listData"></two-handcart>
              <!-- 招聘 -->
              <recruitment :listData="listData"></recruitment>
              <!-- 宠物 -->
              <pet :listData="listData"></pet>
            </div>
            <!-- 最新视频 -->
            <div v-else-if="activeName == 'second'">
              <new-video :lensList="lensList"></new-video>
            </div>
          </el-card>
        </el-col>
        <!-- // 右侧新闻 -->
        <el-col
          class="col-md-3 cl-right new-right"
          :span="6"
          style="maright-left: 16px; margin-top: 0"
        >
          <hafa-see></hafa-see>
          <!-- 入驻商家 -->
          <right-news></right-news>
        </el-col>
        <!-- 我的 -->
        <showLeft></showLeft>
      </el-row>
    </div>
    <!-- 搜索页 -->
    <div class="cl-cantainer" v-else>
      <el-row class="row">
        <el-col class="col-md-9 cl-left" :span="17">
          <div class="box-card-list">
            <ha-faList :listData="listData"></ha-faList>
            <!-- 论坛 -->
            <bbs :listData="listData"></bbs>
            <!-- 今日折扣 -->
            <today-discount :listData="listData"></today-discount>
            <!-- 本地生活 -->
            <local-life :listData="listData"></local-life>
            <!-- 二手交易 -->
            <trading :listData="listData"></trading>
            <!-- 租房 -->
            <rent-house :listData="listData"></rent-house>
            <!-- 二手车 -->
            <two-handcart :listData="listData"></two-handcart>
            <!-- 招聘 -->
            <recruitment :listData="listData"></recruitment>
            <!-- 宠物 -->
            <pet :listData="listData"></pet>
          </div>
        </el-col>
        <!-- // 右侧新闻 -->
        <el-col
          class="col-md-3 cl-right new-right"
          :span="6"
          style="maright-left: 16px; margin-top: 0"
        >
          <hafa-see style="margin-top: 20px"></hafa-see>
          <!-- 入驻商家 -->
          <right-news :keyword="keyword"></right-news>
        </el-col>
        <!-- 我的 -->
        <showLeft></showLeft>
      </el-row>
    </div>
  </section>
</template>

<script>
import Service from "@/api/request/index.js";
import api from "@/api/request1/index.js";
// banner公共区域
import publicBanner from "@/components/publicBanner";
// 右侧新闻
import rightNews from "@/components/rightNews";
// 筛选
import filterClear from "@/components/filter";
// 哈法
import haFaList from "@/components/haFaList";
// 论坛
import bbs from "@/components/bbs";
// 今日折扣
import todayDiscount from "@/components/todayDiscount";
// 本地生活
import localLife from "@/components/localLife";
// 二手交易
import trading from "@/components/trading";
// 租房
import rentHouse from "@/components/rentHouse";
// 二手车
import twoHandcart from "@/components/twoHandcart";
// 宠物
import recruitment from "@/components/recruitment";
// 宠物
import pet from "@/components/pet";
import HafaSee from "@/components/hafaSee.vue";
// 最新视频
import newVideo from "@/components/homeIndex/video.vue";
// 我的弹窗
import showLeft from "@/components/showLeft";

export default {
  name: "home",
  components: {
    publicBanner,
    rightNews,
    filterClear,
    bbs,
    todayDiscount,
    localLife,
    trading,
    rentHouse,
    twoHandcart,
    recruitment,
    pet,
    HafaSee,
    haFaList,
    newVideo,
    showLeft,
  },
  data() {
    return {
      activeName: "first",
      chooseIndex: 1,
      dbcol: true,
      check: true,
      CinemaList: [],
      activeNames: 1,
      arrowShow: false,
      marginLeft: 0,
      currentPage4: 4,
      activeName: "first",
      // 页码/条数
      queryParams: {
        page: 1,
        list_rows: 15,
      },
      listData: [], //新 - 首页最新列表
      publicBannerList: [], //获取指定广告位的广告列表
      publicShuffling: [], //获取首页公告（轮播图下方，固定条数）
      lensList: [], //首页-哈哈镜头接口
      flag: 0, // 定义一个flag变量 充当节流阀
      wait: 1000, // 定义一个wait变量 延迟多长时间触发
      keyword: this.$route.query.keyword || "",
      // code: '',
    };
  },
  watch: {
    $route(to, from) {
      if (from.path == "/home") {
        this.keyword = this.$route.query.keyword;
        this.queryParams.page = 1;
        this.listData = [];
        //获取首页公告（轮播图下方，固定条数）
        this.post62b329d25116a();
        //获取指定广告位的广告列表
        this.post5c94aa1a043e7();
        // 新 - 首页最新列表
        this.post62bbca2331de7();
      }
    },
  },
  created() {
    //获取首页公告（轮播图下方，固定条数）
    this.post62b329d25116a();
    //获取指定广告位的广告列表
    this.post5c94aa1a043e7();
    if (this.keyword) {
      this.headleSearch();
      return;
    }
    // 新 - 首页最新列表
    this.post62bbca2331de7();
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.name == "first") {
        // 新 - 首页最新列表
        this.post62bbca2331de7();
        //获取首页公告（轮播图下方，固定条数）
        this.post62b329d25116a();
        //获取指定广告位的广告列表
        this.post5c94aa1a043e7();
      } else {
        //首页-哈哈镜头接口
        this.post62bbea32751d9();
      }
    },
    // 新 - 首页最新列表
    post62bbca2331de7() {
      Service.post62bbca2331de7(this.queryParams).then((res) => {
        console.log("res", res);
        if (res.code == 1) {
          this.listData = [...this.listData, ...res.data.data];
        }
      });
    },
    //获取首页公告（轮播图下方，固定条数）
    post62b329d25116a() {
      Service.post62b329d25116a().then((res) => {
        console.log("res", res);
        if (res.code == 1) {
          this.publicShuffling = res.data;
        }
      });
    },
    //获取指定广告位的广告列表
    post5c94aa1a043e7() {
      Service.post5c94aa1a043e7({ typeid: 1 }).then((res) => {
        console.log("res", res);
        if (res.code == 1) {
          this.publicBannerList = res.data;
        }
      });
    },
    //首页-哈哈镜头接口
    post62bbea32751d9() {
      Service.post62bbea32751d9(this.queryParams).then((res) => {
        console.log("res", res);
        if (res.code == 1) {
          this.lensList = res.data.data;
        }
      });
    },
    // 计算高度
    handleScroll(event) {
      let scrollHeight = event.target.scrollHeight;
      // 变量 windowHeight 是可视区的高度
      let windowHeight = event.target.clientHeight;
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop = event.target.scrollTop;
      // 滚动条到底部得距离 = 滚动条的总高度 - 可视区的高度 - 当前页面的滚动条纵坐标位置
      var scrollBottom = scrollHeight - windowHeight - scrollTop;
      // console.log("scrollBottom", scrollBottom,scrollHeight,windowHeight,scrollTop)
      if (scrollBottom <= 400) {
        // 新 - 首页最新列表
        if (this.flag) return;
        this.flag = 1; // 执行完一次后 关闭节流阀
        this.queryParams.page++;
        // setTimeout 根据个人需求来定
        if (this.keyword) {
          setTimeout(() => {
            // 需要执行的操作 执行完成后开启节流阀flag = 0;
            // 如果不需要在进行操作 flag无需改变或者flag = 1;
            this.headleSearch();
          }, 1000);
        } else {
          setTimeout(() => {
            // 需要执行的操作 执行完成后开启节流阀flag = 0;
            // 如果不需要在进行操作 flag无需改变或者flag = 1;

            this.post62bbca2331de7();
          }, 1000);
        }
      }
    },
    headleSearch() {
      Service.post62bcf9d10166f({
        keyword: this.keyword,
        page: this.queryParams.page,
        list_rows: this.queryParams.list_rows,
      }).then((res) => {
        if (res.code == 1) {
          this.listData = [...this.listData, ...res.data.data];
          this.flag = 0;
        }
      });
    },
  },
  mounted() {
    // 滚动条的获取
    window.addEventListener("scroll", this.handleScroll, true);
  },
};
</script>

<style scoped lang="scss">
@import "themePath/mainPublic";
@import "themePath/Monitor/index";
@import "themePath/Monitor/cl-css";
@import "themePath/railscasts";
.new-right {
  margin-top: 0;
}

.cl-card-main-title {
  span {
    width: 56px;
    height: 21px;
    line-height: 21px;
    text-align: center;
    display: inline-block;
    background: #ff9b57;
    border-radius: 2px 2px 2px 2px;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    margin-right: 8px;
    color: #ffffff !important;
  }
}
.imgList {
  .cl-card-main-info {
    width: 808px;
    overflow: hidden; /*文本超出隐藏*/
    text-overflow: ellipsis; /*文本超出显示省略号*/
    white-space: nowrap; /*超出的空白区域不换行*/
    height: auto;
    margin: 0 0 8px 0;
  }
  li {
    width: 248px;
    img {
      width: 100%;
      height: 172px;
    }
  }
}
.cl-card {
  padding: 0;
}
.leftMe {
  width: 64px;
  height: 313px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.05);
  border-radius: 4px 4px 4px 4px;
  position: fixed;
  right: 10px;
  bottom: 30px;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  font-size: 18px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: bold;
  color: #333333;
  -webkit-background-clip: text;
}
.elTabs /deep/ .el-tabs__item {
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  padding: 0 !important;
  margin-right: 24px;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom: 2px solid #fee60f;
}

.box-card-list {
  background-color: #fff;
  padding: 20px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/homeIndex/home.vue